export default "__VITE_ASSET__Du4KO8U4__"